import { render } from "./FaceImprovement.vue?vue&type=template&id=2c56ae07"
import script from "./FaceImprovement.vue?vue&type=script&lang=js"
export * from "./FaceImprovement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__